export const iconFontAwesomeLogisticsBridgeCircleExclamation = (
	<i className="fa-solid fa-bridge-circle-exclamation"></i>
);
